import React from 'react'
import { Screen } from '~common/screen'
import { StyledScreen } from '~common/screen'
import UsersHoverIcon from '~images/users_hover.svg'
import BarChartIcon from '~images/bar_chart.svg'
import ClockIcon from '~images/chats-page/clock.svg'
import PieChartIcon from '~images/chats-page/pie_chart_green.svg'
import MessageIcon from '~images/chats-page/message.svg'
import StatusIcon from '~images/chats-page/status.svg'
import LineChartIcon from '~images/chats-page/line_chart.svg'

const ChatBenefits = () => {
  return (
    <Screen
      title={<span>Чаты — это<StyledScreen.GreenText> выгодно</StyledScreen.GreenText></span>}
      bottomLine
      className='chat-benefits'
    >
      <div className="chat-benefits__container">
        <div className="chat-benefits__coll">
          <div className="chat-benefits__coll-title">для бизнеса:</div>
          <div className="chat-benefits__item">
            <div className="chat-benefits__icon"><LineChartIcon /></div>
            <div className="chat-benefits__item-text">Увеличение лояльности действующих и потенциальных клиентов</div>
          </div>
          <div className="chat-benefits__item">
            <div className="chat-benefits__icon"><PieChartIcon /></div>
            <div className="chat-benefits__item-text">Увеличение заявок в бизнес</div>
          </div>
          <div className="chat-benefits__item">
            <div className="chat-benefits__icon"><BarChartIcon /></div>
            <div className="chat-benefits__item-text">Рост конверсии из первичного обращения в квалификацию лида и в клиента</div>
          </div>
          <div className="chat-benefits__item">
            <div className="chat-benefits__icon"><UsersHoverIcon /></div>
            <div className="chat-benefits__item-text">Комфорт для клиента</div>
          </div>
        </div>
        <div className="chat-benefits__coll">
          <div className="chat-benefits__coll-title">для клиента:</div>
          <div className="chat-benefits__item">
            <div className="chat-benefits__icon"><ClockIcon /></div>
            <div className="chat-benefits__item-text">Быстрый ответ на любой запрос, быстрое решение проблемы</div>
          </div>
          <div className="chat-benefits__item">
            <div className="chat-benefits__icon"><UsersHoverIcon /></div>
            <div className="chat-benefits__item-text">Комфорт при общении с компанией</div>
          </div>
          <div className="chat-benefits__item">
            <div className="chat-benefits__icon"><StatusIcon /></div>
            <div className="chat-benefits__item-text">Нет необходимости по несколько раз объяснять одно и то же одному или разным менеджерам</div>
          </div>
          <div className="chat-benefits__item">
            <div className="chat-benefits__icon"><MessageIcon /></div>
            <div className="chat-benefits__item-text">Комфорт дальнейшей коммуникации</div>
          </div>
        </div>
      </div>
    </Screen>
  )
}

export default ChatBenefits